import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Los scripts de WhatsApp cambiaron todo. Antes le tenía miedo a cobrar la seña. Ahora lo hago con un mensaje copiado y pegado y las clientas lo aceptan sin drama.',
    author: 'Laura P.',
    location: 'Manicurista · Rosario',
    initial: 'L'
  }, {
    quote: 'El sistema anti no-show me ahorró lo que vale el pack en la primera semana. Cero cancelaciones sin aviso desde que empecé a usar las 3 capas del Tomo 2.',
    author: 'Micaela R.',
    location: 'Manicurista independiente · CABA',
    initial: 'M'
  }, {
    quote: 'La planilla de costos del Tomo 1 me hizo dar cuenta que estaba cobrando menos de lo que me costaba el servicio. Lo corregí en un día. Ese solo tomo pagó todo el pack.',
    author: 'Julia M.',
    location: 'Manicurista · Tucumán',
    initial: 'J'
  }, {
    quote: 'El consentimiento informado del Tomo 5 me salvó cuando una clienta quiso reclamarme por un diseño de referencia. Tenía todo firmado. Fin de la discusión.',
    author: 'Valeria L.',
    location: 'Manicurista · Córdoba',
    initial: 'V'
  }];
  const Stars = () => <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-323">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-324" />)}
    </div>;
  return <section className="py-14 px-4 max-w-6xl mx-auto bg-black" data-id="element-325">
      <FadeIn data-id="element-326">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-327">
          <span className="text-red-500" data-id="element-328">❤️</span> LO QUE DICEN LOS QUE YA LO
          TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-329">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-330">
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 h-full flex flex-col" data-id="element-331">
              <Stars data-id="element-332" />
              <p className="text-lg text-gray-200 mb-6 italic leading-relaxed flex-grow" data-id="element-333">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-334">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 font-bold" data-id="element-335">
                  {t.initial}
                </div>
                <div data-id="element-336">
                  <p className="font-bold text-white" data-id="element-337">{t.author}</p>
                  <p className="text-sm text-gray-500" data-id="element-338">{t.location}</p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}